import React from 'react'
import { getSponsors, SponsorFragment } from 'src/graphql'
import { useQueries } from 'src/hooks'
import Popover from '@material-ui/core/Popover'
import MenuItem from '@material-ui/core/MenuItem'
import { DefaultError, ProfileAvatar } from 'src/chrome'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import CircularProgress from '@material-ui/core/CircularProgress'

const menuItemStyles = {
  container: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    padding: '5px 0',
  },
  avatar: {
    display: 'flex',
    justifyContent: 'left',
    marginRight: 10,
    alignItems: 'center',
    color: '#FFF',
    fontWeight: 700,
  },
  name: {
    textOverflow: 'ellipsis',
    fontWeight: 700,
    flex: 'auto',
    margin: 0,
    padding: 0,
    lineHeight: 0,
  },
  address: {
    textOverflow: 'ellipsis',
    margin: 0,
    padding: 0,
    lineHeight: '40px',
  },
  sponsorInfo: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
  },
}

type SponsorPopoverProps = {
  searchTerm: string
  onClose: () => void
  onSelect: (sponsor: SponsorFragment) => void
  anchorEl: Element | null
  onError: (error?: string) => void
}

const SponsorPopover: React.FC<SponsorPopoverProps> = props => {
  const { searchTerm, onClose, onSelect, anchorEl, onError } = props

  const [sponsors] = useQueries(
    searchTerm.length > 0 ? getSponsors({ search: searchTerm }) : undefined,
  )

  const isPopoverVisible = !!sponsors && sponsors.length > 0

  sponsors && sponsors.length === 0
    ? onError(
        'No sponsor found. Please select a sponsor or clear the input before joining.',
      )
    : onError(undefined)

  return (
    <Popover
      open={isPopoverVisible}
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'top',
      }}
      transformOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
      anchorReference="anchorEl"
      onClose={onClose}
      disableRestoreFocus={true}
      disableAutoFocus={true}
      disableEnforceFocus={true}
    >
      {sponsors &&
        sponsors.map(sponsor => {
          const { firstName, lastName, storefront, shippingAddress } = sponsor
          const mugshot = storefront && storefront.mugshot
          return (
            <MenuItem key={sponsor.id} onClick={() => onSelect(sponsor)}>
              <div style={menuItemStyles.container}>
                <ProfileAvatar
                  avatarWrapperStyles={{
                    width: 'initial',
                  }}
                  style={menuItemStyles.avatar}
                  size={50}
                  image={mugshot?.url}
                  name={`${firstName} ${lastName}`}
                />
                <div style={menuItemStyles.sponsorInfo}>
                  <span
                    style={menuItemStyles.name}
                  >{`${firstName} ${lastName}`}</span>
                  <span style={menuItemStyles.address}>
                    {shippingAddress &&
                      `${shippingAddress.city}, ${shippingAddress.state}`}
                  </span>
                </div>
              </div>
            </MenuItem>
          )
        })}
    </Popover>
  )
}

export default suspenseBoundary({
  component: SponsorPopover,
  unresolved: (
    <CircularProgress
      style={{
        position: 'absolute',
        right: 30,
        top: 15,
        width: 10,
        height: 10,
      }}
    />
  ),
  failure: DefaultError,
})
